import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import './Spinner.scss'

function CircularIndeterminate(styles) {
  return <CircularProgress {...styles} variant="indeterminate" value={100} className="spinner" />
}

export default CircularIndeterminate
